<template>
  <v-container>
      <!-- v-row justify="center" alignment="center" no-gutters>
          <v-col cols="1" >
              <v-img
                :src="lashesLeft.src"
                contain
                :max-height="lashHeight"
                class="jog-down float-right margin-sm-right"
              ></v-img>
          </v-col>
          <v-col cols="auto" class="text-white heading-block">
              <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.mdAndDown}">{{this.langData.faq.title}}</h1></div>
          </v-col>
          <v-col cols="1" alignment="center">
              <v-img
                :src="lashesRight.src"
                contain
                :max-height="lashHeight"
                class="jog-down float-left margin-sm-left"
                center
              ></v-img>
          </v-col>
      </!-->

      <v-row justify="center" alignment="center" no-gutters>
          <v-col cols="10" md="7" class="text-green">
              <p class="center-text mid-size" :class="{'tighten-leading': $vuetify.breakpoint.smAndDown}"><b v-html="this.langData.faq.body"></b></p>
          </v-col>
      </v-row>

    <div v-for="(data,i) in faqData" :key="i">
      <v-row justify="center" alignment="center" no-gutters class="heading-row">
          <v-col cols="2" md="1" class="rays-left">
          </v-col>
          <v-col cols="8" md="auto" class="text-white heading-block">
              <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.smAndDown}">{{i}}</h1></div>
          </v-col>
          <v-col cols="2" md="1" class="rays-right">
          </v-col>
      </v-row>
      <v-row justify="center">
          <v-col cols="auto">
            <v-expansion-panels 
              focusable
              active-class="panel-open"
              flat>
                <v-expansion-panel
                v-for="(item,i) in data"
                :key="i"
                >
                <v-expansion-panel-header>
                  <div v-html="i" class="faq-headers"></div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card outlined>
                        <v-card-text v-html="item"></v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
      </v-row>
    </div>
    
  </v-container>
</template>

<script>

  export default {
    props:['langData', 'faqData'],
    data: () => ({
      name : 'faq',
      lashesRight : {src:require('../assets/lashesRight.png')},
      lashesLeft : {src:require('../assets/lashesLeft.png')},
      lashHeight: '38px',
    })
  }
</script>
<style scoped>
  h1.center-text.arla-strong {
    font-size: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>